export const Seg = ({ children }) =>
<>{children}</>;
